// removed by extract-text-webpack-plugin
module.exports = {"vpModalContainer":"vpModalContainer___3anQ7","vpModalWarning":"vpModalWarning___eqxrq","vpModalActions":"vpModalActions___2eyzP","vpModalIcon":"vpModalIcon___1JOXK","vpModalDeleteButton":"vpModalDeleteButton___Gm6kp"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaDownloadModal.module.less
// module id = 3366
// module chunks = 31